import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Logo from "../components/Logo";
import ThemeToggle from "../components/ThemeToggle";

export default function NotFound() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Joborigo — Page not found";
    return () => {
      document.title = "Joborigo — Your job search, in the front seat";
    };
  }, []);

  return (
    <div className="min-h-screen bg-brand-light-bg dark:bg-brand-dark-bg flex flex-col">
      <nav className="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-white/10 bg-white dark:bg-brand-dark-surface">
        <Logo className="h-12" />
        <ThemeToggle />
      </nav>

      <div className="flex-1 flex items-center justify-center px-4">
        <div className="text-center max-w-md">
          <div className="text-8xl mb-6 select-none">👻</div>

          <p className="text-xs font-semibold text-brand-violet dark:text-brand-violet-on-dark uppercase tracking-widest mb-3">
            404 — Not found
          </p>
          <h1 className="text-3xl font-extrabold text-gray-900 dark:text-white mb-3 leading-tight">
            Nope, you won't find
            <br />
            any jobs here.
          </h1>
          <p className="text-gray-400 text-base mb-8">
            Go back and try again — your next opportunity is one click away.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={() => navigate(-1)}
              className="border border-gray-200 dark:border-white/10 text-gray-600 dark:text-gray-300 px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-gray-50 dark:hover:bg-white/5 transition"
            >
              ← Go back
            </button>
            <Link
              to="/"
              className="bg-brand-violet text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:opacity-90 transition"
            >
              Back to Joborigo
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
